// src/components/MenuItemImage.tsx
import React, { useState } from "react";
import { View, Image, TouchableOpacity, Text, StyleSheet } from "react-native";
import { MenuItemType } from "../components/shared/types/restaurant.types";
import { menuScreenStyles as styles } from "../components/shared/styles/styles";
import { QuantityControl } from "../components/QuantityControl";

interface MenuItemImageProps {
  item: MenuItemType;
  onAddToCart: (item: MenuItemType, quantity: number) => void;
}

const MenuItemImage = ({ item, onAddToCart }: MenuItemImageProps) => {
  const [quantity, setQuantity] = useState(0);

  const handleAdd = () => {
    const newQuantity = quantity + 1;
    setQuantity(newQuantity);
    onAddToCart(item, newQuantity);
  };

  const handleQuantityChange = (change: number) => {
    const newQuantity = Math.max(0, quantity + change);
    setQuantity(newQuantity);
    onAddToCart(item, newQuantity);
  };

  return (
    <View>
      <Image
        source={
          item.imageUrl
            ? { uri: item.imageUrl }
            : require("../../assets/pavBhaji.jpeg")
        }
        style={styles.itemImage}
      />
      <QuantityControl
        quantity={quantity}
        handleAdd={handleAdd}
        handleQuantityChange={handleQuantityChange}
      />
    </View>
  );
};

export default MenuItemImage;
